import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import constants from '../constants';

Vue.use(Vuex);

export default new Vuex.Store({
  state: constants.DefaultState(),
  getters,
  mutations,
  actions,
});
